
import { mapState, mapMutations } from "vuex";
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

export default {
name: "Lang",
components: { Actionsheet },
inject: ["parentRoot"],
data() {
return {
langsShow: false,
actions: [{ text: "选项一" }, { text: "选项二" }, { text: "选项三" }],
};
},
computed: {
...mapState({
langs: (state) => state.langs,
}),
langsLogo() {
return require(`../../../assets/image/langs/${this.langs.keys}.png`);
},
langsMenu() {
const { keys, langsOptions } = this.langs;
return langsOptions[keys];
},
},
created() {},
mounted() {},
methods: {
...mapMutations(["setlangs"]),
handleSetLang(lang) {

this.$i18n.locale = lang;

this.$Cookies.set("lang", lang);
this.setlangs({ keys: lang });
window.location.reload();

},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/components/Lang/index.vue